import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Business } from 'src/app/models/Businesses';
import { Employee } from 'src/app/models/Employees';
import { Invite } from 'src/app/models/Invite';
import { UserPd } from 'src/app/models/UserPd';
import { User } from 'src/app/models/Users';
import { ToastService } from 'src/app/util/toast.service';

import { AuthService } from '../auth.service';
import { JsonService } from '../json.service';
import { BackEndService } from '../backEnd.service';
import { WhatsappService } from '../whatsapp.service';
import { EmployeeSService } from './employeeS.service';

@Injectable({
  providedIn: 'root',
})
export class InviteService {
  invite: Invite = new Invite;
  inviteList: Invite[] = [];
  showPincodeOption1: boolean = false;
  filteredPinCode = [];


  constructor(private backEnd: BackEndService,
    private toast: ToastService, private whatsappService: WhatsappService,
    private auth: AuthService, public jsonService: JsonService, private empService: EmployeeSService) {
    this.auth.getLoggedInEmployee();
  }

  getSingleInvite(id, variable?, skipInService?: boolean) {
    return new Promise<Invite>((resolve) => {
      this.backEnd.getSingle(appConfig.STORAGE_TABLE.INVITE, [[variable ?? "id", id]]).then((invite: Invite) => {
        if (!skipInService && invite) {
          this.invite = invite;
          console.log(this.invite);
        }
        resolve(invite);
      });
    });
  }

  saveObject(invite) {
    return new Promise((resolve) => {
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.INVITE, invite).then((response) => {
        if (response) {
          let found = this.inviteList.find(x => x.id == invite.id);
          if (!found) {
            this.inviteList.unshift(invite);
          }
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  updateStatus(inviteList?: Invite[]) {
    return new Promise((resolve) => {
      inviteList = inviteList ?? this.inviteList;
      let objList = [];
      for (let obj of inviteList) {
        let update = {
          ...obj,
          updated_at: new Date(),
        }
        objList.push(update);
      }

      this.backEnd.updateList(appConfig.STORAGE_TABLE.INVITE, objList).then((response) => {
        if (response != null) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getAllRequest(status) {
    return new Promise((resolve) => {
      let query = [["status", status]];
      // access = JSON.parse(access);
      // for (let key in access) {
      // let varVal = item.split(":");
      // query.push([varVal[0], varVal[1].split(";"), "in"])
      // query.push([key, access[key], "in"])
      // }
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.INVITE, query).then((requestList: Invite[]) => {
        this.inviteList = requestList;
        resolve(this.inviteList);
      })

    })
  }

  setAddress(pin, invite: any) {
    invite.pincode = pin.split(':')[0];
    invite.area = pin.split(':')[1].split(",")[0];
    invite.town = pin.split(':')[1].split(",")[1];
    for (let key in this.jsonService.districtList) {
      if (this.jsonService.districtList[key] && (this.jsonService.districtList[key] + "").split(", ")[1] == invite.pincode.substring(0, 3)) {
        invite.state = (this.jsonService.districtList[key] + "").split(", ")[0];
        invite.district = key;
      }
    }
    if (!invite.town) {
      invite.town = invite.district;
    }

    invite.country = "India";
    invite.complete_address = invite.area + ", " + invite.town + ", " + invite.state + ", " + invite.country + ", " + invite.pincode;
    this.showPincodeOption1 = false;
    console.log(invite);
  }

  searchPincode(search) {
    console.log(search, this.showPincodeOption1, this.filteredPinCode);
    if (search.length > 3) {
      this.showPincodeOption1 = true;
      this.filteredPinCode = this.jsonService.areaList.area.filter(x => x.toLowerCase().indexOf(search.toLowerCase()) > -1);
    } else {
      this.showPincodeOption1 = false;
    }
  }


  createEmp(invite) {
    return new Promise((resolve) => {
      let user = new User();
      let nameArray = invite.name.split(' ');
      user.name = nameArray[0];
      if (nameArray.length > 0) {
        user.last_name = invite.name.replace(user.name, '').trim();
      }
      this.empService.saveUser('user', user).then(() => {
        let userPd = new UserPd();
        userPd.created_at = new Date();
        userPd.mobile = invite.mobile;
        userPd.id = user.id;
        userPd.pincode = invite.pincode;
        userPd.current_address2 = invite.complete_address;
        userPd.user_id = user.id;
        this.empService.saveUser('user_pd', userPd).then(() => {
          this.empService.employee = new Employee();
          this.empService.employee.user_id = user.id;
          this.empService.employee.access = [];
          this.empService.employee.type = "Community";
          this.empService.employee.created_by = invite.emp_id ?? "Admin";
          this.empService.employee.business_id = invite.business_id;
          this.empService.saveUser('employee', this.empService.employee).then(() => {
            this.empService.employee.user = user;
            this.empService.employee.user.user_pd = userPd;

            resolve(this.empService.employee);
            // });
          });
        });
      });
    });
  }

  inviteValidation(invite: Invite): boolean {
    let valid = true;
    if (!invite.mobile) {
      valid = false;
      this.toast.error('Mobile is mandatory');
    }
    if (!invite.name) {
      valid = false;
      this.toast.error('Name is mandatory');
    }
    if (!invite.complete_address) {
      valid = false;
      this.toast.error('Select address from pincode');
    }

    return valid;
  }
  createInvite(biz?: Business, relative?: Employee, relation?: string, selectedEmp?: Employee) {
    this.backEnd.searchObject(appConfig.STORAGE_TABLE.INVITE, [
      ["emp_id", this.auth.loggedInEmployee.id],
      ["business_id", biz ? biz.id : this.auth.loggedInEmployee.business_id],
      ["status", "OPEN"]]).then(async (inviteList) => {
        let invite: Invite;
        if (inviteList && inviteList.length > 0) {
          invite = inviteList[0];
        }
        if (!invite || biz) {
          invite = new Invite();
        }

        invite.emp_id = this.auth.loggedInEmployee.id;
        invite.name = this.auth.loggedInEmployee.user.name;
        invite.complete_address = this.auth.loggedInEmployee.user.user_pd.current_address2;
        invite.mobile = this.auth.loggedInEmployee.user.user_pd.mobile;
        invite.status = "OPEN";
        invite.type = "Direct";
        invite.via = "Whatsapp";
        invite.logo = biz ? biz.logo : this.auth.business.logo;
        invite.business_id = biz ? biz.id : this.auth.loggedInEmployee.business_id;
        invite.pincode = this.auth.loggedInEmployee.user.user_pd.pincode;
        invite.community = biz ? biz.name : this.auth.business.name;
        invite.sub_community = biz ? "" : this.auth.loggedInEmployee.user.user_pd.sub_community;
        invite.email = this.auth.loggedInEmployee.user.user_pd.email; // Used as message
        invite.country = this.auth.loggedInEmployee.user.user_pd.country;
        invite.state = this.auth.loggedInEmployee.user.user_pd.state;
        invite.district = this.auth.loggedInEmployee.user.user_pd.district;
        invite.area = this.auth.loggedInEmployee.user.user_pd.area;
        invite.town = this.auth.loggedInEmployee.user.user_pd.town;
        if (biz) {
          invite.remarks = "Vanshavali Admin";
        } else {
          invite.remarks = this.auth.loggedInEmployee.assigned_area ? this.auth.loggedInEmployee.assigned_area[0] : null;
        }
        await this.saveObject(invite);
        this.whatsappService.inviteSheet(invite, relative, relation, selectedEmp);
      });
  }

}
